module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    staticClass: "bg-grey-white",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "display-flex justify-space-between bg-grey-white-4 align-center pa-4"
  }, [_c('v-select', {
    staticClass: "normal-input ml-4",
    attrs: {
      "items": _vm.genre_categories,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    model: {
      value: (_vm.genre_category),
      callback: function($$v) {
        _vm.genre_category = $$v
      },
      expression: "genre_category"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "genre-add display-flex justify-center gap-4 align-center"
  }, [_c('v-icon', {
    staticClass: "genre-add__icon"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "text-white font-poppins text-14"
  }, [_vm._v("Add new subgenre")])], 1)], 1), _vm._v(" "), _c('table', {
    staticClass: "w-100 custom-table px-4"
  }, [_c('tbody', {
    staticClass: "custom-table__tbody"
  }, _vm._l((_vm.filtered_genres), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-3 font-poppins text-16 font-weight-600"
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _vm._v(" "), _c('td')])
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-638c7c64","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/genres.vue
// module id = 1750
// module chunks = 180